module.exports = __webpack_public_path__ + "img/yb5.4d178990.jpg";